import asArray from '../utils/asArray'
import deUnderscore from '../utils/deUnderscore'

export default function wineProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  const mapTaxonomyById = Object.values(taxonomyMap).reduce((acc, terms) => {
    return {
      ...acc,
      ...terms.reduce((acc2, t) => ({ ...acc2, [t.name.replace('_', '')]: t.description }), {})
    }
  }, {})

  return {
    dateChanged: function() { return this.modified },
    ptype: function() {
      const map = {
        shippable: 'tangible',
        nonshippable: 'generic',
        event: 'event_ec_product'
      }
      return map[this.producttype]
    },
    cart_multiple: function() {
      return this.productsettings.cartmultiple
    },
    sticky: function() {
      return parseInt(this.featured) || 0
    },
    sweetness: function() {
      return parseInt(deUnderscore(this.sweetness)) || 0
    },
    rrp: function() {
      return this.wineproductrrp
    },
    discountGroup: function() {
      if (this.productsettings.discountgroup) {
        return {
          [this.productsettings.discountgroup.replace(/_(\d+)/, '$1')]: mapTaxonomyToValue(this.productsettings.discountgroup, 'discount_group')
        }
      }
      return {}
    },
    sweetnessDesc: function() {
      return mapTaxonomyToValue(this.sweetness, 'sweetness')
    },
    series: function() {
      return mapTaxonomyToValue(this.series, 'series')
    },
    brand: function() {
      return mapTaxonomyToValue(this.brand, 'brand')
    },
    attributes: function() {
      if (this.attributes.length > 0) return this.attributes.map(item => mapTaxonomyToValue(item, 'attributes'))
      else return []
    },
    collections: function() {
      if (this.collections.length > 0) return this.collections.map(item => mapTaxonomyToValue(item, 'collections'))
      else return []
    },
    producer: function() {
      return this.producer ? this.producer.name : ''
    },
    pack_size: function() {
      return this.pack_size ?? 1
    },
    region: function() {
      return mapTaxonomyToValue(this.region, 'region')
    },
    winebody: function() {
      return mapTaxonomyToValue(this.winebody, 'winebody')
    },
    seriesLabel: function(store) {
      return (this.series && this.series !== '')
        ? store.getters['config/getTermLabelFromEnum'](deUnderscore(this.series)) ?? ''
        : ''
    },
    path_prefixed_slash: function() {
      // Guard against an empty/missing seo.path (e.g. a product never
      // assigned a public URL) - '/' + '' collides with the root route,
      // which made findByRoutePath('/') incorrectly match a pathless
      // product instead of falling through to the real homepage lookup.
      return (this.seo && this.seo.path) ? '/' + this.seo.path : ''
    },
    path: function() {
      return this.seo.path
    },
    varietals: function() {
      const v = asArray(this, 'varietal')
      if (v.length > 0) return v.map(item => mapTaxonomyToValue(item, 'varietal'))
      else return ['Other Varietals']
    },
    wine_type: function() {
      if (this.wine_type && this.wine_type !== 'unknown') return this.wine_type
      else return 'Other Wine Type'
    },
    changed: function() {
      return this.modified
    },
    sku: function() {
      return this.productsettings.sku
    },
    taxonomy: function() {
      let series = ''
      if (this.series) {
        series = this.series.replace('_', '')
      }
      let productSettings = ''
      if (this.productsettings && this.productsettings.discountgroup) {
        productSettings = this.productsettings.discountgroup.replace('_', '')
      }
      let tids = []
      if (this.wine_club) {
        tids = this.wine_club.filter(tid => tid).map(tid => tid.replace('_', ''))
      }
      return [
        series,
        productSettings,
        ...tids
      ].reduce((acc, tid) => ({ ...acc, [tid]: mapTaxonomyById[tid] }), {})
    }
  }
}
